import Index from "./components/Index.vue";
import Articol from "./components/articol.vue";
import Categorie from "./components/categorie.vue";
import Recomanda from "./components/recomanda.vue";
import CatalogOpac from "./components/catalogopac.vue";
import BibliotecaDigitala from "./components/bibliotecadigitala.vue";
import SubBibliotecaDigitala from "./components/bibliotecadigitalasub.vue";
import Digital from "./components/digital.vue";
import Continutdigital from "./components/continutdigital.vue";
import Harta from "./components/harta.vue";
import IntreabaUnBibliotecar from "./components/intreabaunbibliotecar.vue";
import Pagina from "./components/pagina.vue";
import Articole from "./components/articole.vue";
import DespreNoi from "./components/desprenoi.vue";
import VeziHarta from "./components/veziharta.vue";

const routes = [
  { path: "/", component: Index },
  { path: "/articol/:id", component: Articol, props: true },
  { path: "/categoria/:id/:nume", component: Categorie, props: true },
  { path: "/recomanda", component: Recomanda },
  { path: "/catalogopac", component: CatalogOpac },
  { path: "/bibliotecadigitala/", component: BibliotecaDigitala },
  { path: "/subbibliotecadigitala/:id", component: SubBibliotecaDigitala },
  { path: "/digital/:id", component: Digital },
  { path: "/continutdigital/:id", component: Continutdigital },
  { path: "/harta", component: Harta },
  { path: "/intreabaunbibliotecar", component: IntreabaUnBibliotecar },
  { name: "pagina", path: "/pagina/:id", component: Pagina },
  { path: "/articole/", component: Articole, props: true },
  { path: "/desprenoi/", component: DespreNoi, props: true },
  { path: "/vezi/:slug", component: VeziHarta },
];

export default routes;
